import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleCalendarUrl } from "./Components/Integrations/apiService";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./Components/Integrations/authConfig";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './i18n'; 
import { SnackbarProvider } from "./context/SnackBarContext";

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <MsalProvider instance={msalInstance}>
    <GoogleOAuthProvider clientId={GoogleCalendarUrl.GOOGLE_CALENDAR_CLIENT_ID}>
      <SnackbarProvider>
      <App />
    </SnackbarProvider>
      <ToastContainer position="top-right" autoClose={5000} />
    </GoogleOAuthProvider>
  </MsalProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
